/**
 * @see https://github.com/jsdom/jsdom/releases/tag/12.0.0
 * @see https://github.com/jsdom/jsdom/issues/1537
 */
const isJsDomEnvironment = () =>
	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	window.name === 'nodejs' ||
	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	navigator?.userAgent.includes('Node.js') ||
	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	navigator?.userAgent.includes('jsdom');

export const isServerEnvironment = (): boolean => {
	if (
		typeof window === 'undefined' ||
		(typeof process !== 'undefined' && process.versions != null && process.versions.node != null)
	) {
		return true;
	}

	if (isJsDomEnvironment()) {
		return true;
	}

	return false;
};
